import type { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { getQueryClient } from "@/api/query-client";
import type { AuthContextType } from "@/context/auth-context";
import { log } from "@/lib/log";
import { routeTree } from "@/routeTree.gen";

export interface MyRouterContext {
  queryClient: QueryClient;
  auth: AuthContextType;
}

export const router = createRouter({
  routeTree,
  context: {
    queryClient: getQueryClient(),
    auth: undefined as unknown as AuthContextType,
  },
  defaultPreload: "intent",
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
  defaultOnCatch: (error, eInfo) => {
    log.error("Router error caught", error, eInfo);
  },
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
